import * as React from 'react';

import styles from './SwipeHandle.module.css';

export const SwipeHandle = ({ onClick }: { onClick: () => void }) => {
  return <div className={styles['handle']} onClick={onClick} />;
};
